import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_colabella-tutorials/artifacts/wcwuz41r_LOGO.png';

const TopBar = () => {
  return (
    <div className="top-brand-bar">
      <div className="brand-logo-row">
        <img src={LOGO_URL} alt="Colabella Group" className="brand-logo-img" />
        <span className="brand-logo-text">Colabella Group</span>
      </div>
    </div>
  );
};

export default TopBar;
export { LOGO_URL };
